const r = { align: "end" };
function m(t = r) {
  return (o) => {
    if (o.atBottom)
      return requestAnimationFrame(() => o.scrollToBottom(t));
  };
}
function u(t = r) {
  return (o) => requestAnimationFrame(() => o.scrollToBottom(t));
}
function i(t = r) {
  return (o) => requestAnimationFrame(() => o.scrollToBottom(t));
}
function l(t = r) {
  return (o) => {
    if (o.atBottom)
      return requestAnimationFrame(() => o.scrollToBottom(t));
  };
}
function s(t, o = r) {
  return (n, e) => e.some(t) ? requestAnimationFrame(() => n.scrollToBottom(o)) : l(o)(n, e);
}
function f(t = r) {
  return (o, n) => {
    if (n && o.atBottom)
      return requestAnimationFrame(() => o.scrollToBottom(t));
  };
}
export {
  u as followAlways,
  m as followAtBottom,
  i as followEveryMessage,
  l as followMessagesAtBottom,
  s as followMessagesBy,
  f as followSuffixAtBottom
};
